import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import useProductNode from '../_PRODUCT/useProductNode.jsx'
import meta from './metaKm.mjs'
import Model from './ModelKm.mjs'
import api from './apiKm.mjs'
import PropertiesPane from './PropertiesPaneKm.jsx'

export default () => {
    const ProductNode = useProductNode()

    return extendNode(ProductNode, {
        ...meta,
        api,
        Model,
        PropertiesPane,

        canMountType(map, node, type) {
            return /^(AR|CAT|DOC|PIC|URL)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'AR'},
                {type: 'CAT'},
                {type: 'PIC'},
                {type: 'DOC'},
                {type: 'URL'},
            ]
        },

        _fixChild(map, node, child) {
            return map.BizNode.AR._fixChild(map, node, child)
        },

        _getThemeColor(map, node) {
            return Color.LIGHT_GREY
        },
    })
}
